import HealthRecordFilter from './HealthRecordFilter';

export default HealthRecordFilter;



// WEBPACK FOOTER //
// ./src/components/Pages/Health/HealthRecordFilter/index.js